module.exports = __webpack_public_path__ + "static/media/posicao_amamentar.bd313622.jpg";